import gql from 'graphql-tag';

const deleteBadgingBlacklistMutation = gql`
  mutation DeleteBadgingBlacklist($input: DestroyBadgingBlacklistInput!) {
    deleteBadgingBlacklist(input: $input) {
      success
      errors
      badgingBlacklistId
    }
  }
`;

export default deleteBadgingBlacklistMutation;
